import React, { useEffect } from 'react';
import GoUp from '../scripts/GoUp.js';
import TitleLastProjects from './../atoms/PageLastProjects/TitleLastProjects.jsx'
import SectionLastProjects from './../organisms/SectionLastProjects.jsx'



const PageLastProjects = () => {

    useEffect(() => {
        GoUp()
    }, [])

    return(
        <main className="main">
            < TitleLastProjects />
            < SectionLastProjects />
        </main> 
    )
}

export default PageLastProjects;